import React, {useState} from "react";
import { useForm, Controller, control, NavLink } from "react-hook-form";
import Select, { StylesConfig }  from "react-select";
import {Input, Button, Box, Stack, AppBar, styled, Toolbar,Typography, InputBase,Avatar } from "@mui/material";
import { theme, Badge, } from "@material-ui/core";
import  HomeOutlinedIcon  from "@mui/icons-material/HomeOutlined";
import chroma from 'chroma-js';
import Header from "./../../components/Header.jsx";
import { DatePicker, Space } from 'antd';
import TableXDataGrid from "../form/TableXDataGrid.jsx";
import { ColorModeContext } from "../../theme.js";


export default function PRFHooks() {
 
      
    const {
      register,
      control,
      handleSubmit,
      watch,
      formState: { errors },
    } = useForm()
    //
    const[tableColumns, setTableColums]=useState(
      [
        {'id': 1, 'title': 'ID', 'name': 'id'},
        {'id': 2, 'title': 'First Name', 'name': 'first_name'},
        {'id': 3, 'title': 'Middle Name', 'name': 'middle_name'},
        {'id': 4, 'title': 'Last Name', 'name': 'last_name'},
        {'id': 5, 'title': 'Telephone', 'name': 'telephone'},
        {'id': 6, 'title': 'Email', 'name': 'email'},
        {'id': 7, 'title': 'Gender', 'name': 'gender'},
    ]
    )
    //
   
    const colourStyles = {
      control: styles => ({ ...styles, backgroundColor: "white" }),
      option: (styles, { data, isDisabled, isFocused, isSelected }) => {
        const color = chroma(ColorModeContext.color)
        return {
          ...styles,
          backgroundColor: isDisabled
            ? undefined
            : isSelected
            ? data.color
            : isFocused
            ? color.alpha(0.1).css()
            : undefined,
          color: isDisabled
            ? "#ccc"
            : isSelected
            ? chroma.contrast(color, "white") > 2
              ? "white"
              : "black"
            : data.color,
          cursor: isDisabled ? "not-allowed" : "default",
    
          ":active": {
            ...styles[":active"],
            backgroundColor: !isDisabled
              ? isSelected
                ? data.color
                : color.alpha(0.3).css()
              : undefined
          }
        }
      },
      input: styles => ({ ...styles, ...dot() }),
      placeholder: styles => ({ ...styles, ...dot("#ccc") }),
      singleValue: (styles, { data }) => ({ ...styles, ...dot(data.color) })
    }
    
    //
    const dot = (color = 'transparent') => ({
      alignItems: 'center',
      display: 'flex',
    
      ':before': {
        backgroundColor: color,
        borderRadius: 10,
        content: '" "',
        display: 'block',
        marginRight: 8,
        height: 10,
        width: 10,
      },
    });

    
    const customStyles = {
      option: (base, { data, isDisabled, isFocused, isSelected }) => {
      return {
        ...base,
        backgroundColor: isFocused ? "#6BD5C0" : "#03735D",
        //backgroundColor: isFocused ? "#6BD5C0" : "#320B63",
      };
    }
  };
    //
    const [submitClicked, changeSubmitClicked]=useState(false);
    const [txtFullName, changeTxtFullName]=useState('');
    const [txtFullNameSimilar, changeTxtFullNameSimilar]=useState(' ');
    
    //
     const tableXDataGridColumns =[
        {
          field: 'id',
          headerName: 'ID',
          flex: 1,
          cellClassName: 'name-column--cell',
          type: 'number',
          align: 'left'
      },
      {
        field: 'first_name',
        headerName: 'First Name',
        flex: 1,
        cellClassName: 'name-column--cell',
        type: 'string',
        align: 'center'
      },
    {
      field: 'middle_name',
      headerName: 'Middle Name',
      flex: 1,
      cellClassName: 'name-column--cell',
      type: 'string',
      align: 'left'
  },
  {
    field: 'last_name',
    headerName: 'Last Name',
    flex: 1,
    cellClassName: 'name-column--cell',
    type: 'string',
    align: 'left'
  },
  {
  field: 'telephone',
  headerName: 'Telephone',
  flex: 1,
  cellClassName: 'name-column--cell',
  type: 'string',
  align: 'left'
  },
    {
    field: 'email',
    headerName: 'Email',
    flex: 1,
    cellClassName: 'name-column--cell',
    type: 'string',
    align: 'left'
    },

    {
      field: 'gender',
      headerName: 'Gender',
      flex: 1,
      cellClassName: 'name-column--cell',
      type: 'string',
      align: 'left'
      },
     ]
    //
    const onChangeDate = (date, dateString) => {
  
      console.log("date=" + date);
      console.log("dateString=" + dateString);
      console.log(date, dateString);
      setPatientDOB(dateString);
      console.log("PatientDOB=" + patientDOB);
  };
    //
    const validateString=(stringValue, similarStringValue)=>{
      let validateString=false
      if(stringValue==="" || stringValue==similarStringValue){
        validateString=true
      }
    }

    function validateOnSubmit(){
          let validateOnSubmitStatus=false;
          validateString=(txtFullName, txtFullNameSimilar)
          
          return validateOnSubmitStatus
    }
    //
    const [firstName, setFirstName] = useState('');
    
    let formData=[
      {'name': 'txtFirstName', 'value': firstName, 'type': 'string'}
    ]

    
    //
    const onSubmit = (data) => { 
      //alert("");
      //console.log(event.target[0].value)
      console.log(data['txtFirstName']);
      console.log("formData0=" + formData[0]);
      return;
      //alert("form=" + form[0]);
      //inputProps
      changeSubmitClicked(true);
      let validateStatus=validateOnSubmit();
      console.log("data=" + data)
      console.log("dt__=" + JSON.stringify(data))
      console.log("validateStatus=" + validateStatus)
      if (validateStatus==true){
        console.log("error=" + true)
        return;
      }
      return;
      const jsonObj=data;
      const myobj={
            first_name: jsonObj['txtFirstName'],
            middle_name: jsonObj['txtMiddleName'],
            last_name: jsonObj['txtLastName'],
            telephone: jsonObj['txtMobileNo'],
            nationality: "TZ",
            gender: patientGender['value'],
            dob: patientDOB + ' 00:00:00.00000',
            status: jsonObj['paymentMethod'],
            age: jsonObj['txtAge'],
            address: jsonObj['txtFirstName'],
            patient_code: "ABCDEFG",
            //status: jsonObj['payment_method']
      }
      const APIURL="/myapi/crnewpatient";
      const bodyJSON=JSON.stringify(data);
      const requestOptions ={
        method: 'POST',
        headers: { 'Content-Type':'application/json' },
        body: JSON.stringify(myobj),
      };
     // return;
      try {
               console.log("bb=" + requestOptions);
               fetch(APIURL, requestOptions)
               .then( (response) =>  response.json())
               .then( (data) => console.log(data))
               .then( (data) => alert(data))
          }
     catch(err) {
     console.log(err.message);
       }
    }
     
    const insuranceCategoryValues=[
      { value: 'Select Insurance Category', label: 'Select Insurance Category' },
      { value: 'NHIF', label: 'NHIF' },
      { value: 'ABC', label: 'ABC' },
      //'Male', 'Female' placeholder="Select Insurance Category"
    ]
    
    
    const genderValues=[
      { value: 'Select Gender', label: 'Select Gender' },
      { value: 'Male', label: 'Male' },
      { value: 'Female', label: 'Female' },
      //'Male', 'Female' placeholder="Select Insurance Category"
    ]
    
    
    const onOptionChangeHandler = (event) => {
      console.log("User Selected Value - ", event.target.value);
    }
    
    const [patientGender, setPatientGender]=useState({label :'Select Gender', value:'Select Gender' });
    //console.log(watch("example")) // watch input value by passing the name of it

    const [patientDOB, setPatientDOB]=useState('');
    
    const findGender = (event) => {
      //console.log("e0=" + event[0].value);
      console.log("e=" + event);
      setPatientGender(event);
    }
    

    const [insuranceCategory, setInsuranceCategory]=useState(
      { value: 'Select Insurance Category', label: 'Select Insurance Category' }
      );
    //console.log(watch("example")) // watch input value by passing the name of it

    const findInsuranceCategory = (event) => {
      //console.log("e0=" + event[0].value);
      console.log("e=" + event);
      setInsuranceCategory(event);
    }

    const StyledBox= styled(Box)({
      marginLeft: "10px",
      marginRight: "10px",
      marginTop: "10px",
    })


    const StyledInput= styled(Input)({
      width: "100%",
      fontSize: "14px",
      //fontColor: "black",
      height: "95%",
      marginBottom: "2px",
      marginTop: "2px",
    })

    {/**
    const StyledInput= styled(Input)({
      width: "100%",
      fontSize: "14px",
      fontColor: "black",
      height: "95%",
      marginBottom: "2px",
      marginTop: "2px",
    })
  **/}
    
    const StyledSelect= styled(Select)({
      width: "100%",
      fontSize: "14px",
      fontColor: "white",
      height: "95%",
      marginBottom: "2px",
      marginTop: "2px",
    })

    const TXTRoundedDiv = styled("div")(({ theme }) => ({
      backgroundColor: "",
      border: '1px solid #6BD5C0',
      //borderColor: "#6BD5C0",
      /** 
       * #6BD5C0
       * #8868B0
       *#320B63
       #01579b
       #4527a0
       #311b92
      **/
      borderRadius: theme.shape.borderRadius,
      width: "100%",
      fontSize: "14px",
      marginBottom: "10px"
    }));
   
    {/**
    const TXTRoundedDiv = styled("div")(({ theme }) => ({
      backgroundColor: "grey",
      borderRadius: theme.shape.borderRadius,
      width: "100%",
      fontSize: "14px",
      marginBottom: "10px"
    }));
  **/}
   
    const node = document.querySelector("#app");

    const changeDate = (jsDate, dateString) => {
      // ...
    };
    
    const [patientsRecordsUrl, setPatientsRecordsUrl]=useState('myapi/rpatients');
    //const [patientDOB,]
    const onChangeDOB = (date, dateString) => {
      console.log(date, dateString)
      setPatientDOB(dateString)
      console.log("pdob=" + patientDOB)
    };
    

    /***
    ***/
    /** **/
    const myBox=()=> {
      return <div className="box"> ABC </div>;
      {/**{showRecords ? <myBox /> : <PRFHooks/>}**/}
    }
    const tOPButtonOnClick = () =>{
       if(showForm==true){
        setShowForm(false)
        setTopButtonLabel('Show Form')
       }
       else{
        setShowForm(true)
        setTopButtonLabel('Show Records')
       }
    }
    const [showForm, setShowForm] = useState(true);
    const [topButtonLabel, setTopButtonLabel]=useState('Show Records');
    
    function changeFirstName(e){
      // setFirstName(e);
      console.log("eeh=" + e);
      setFirstName(e ? e: "");
    }

    const[middleName, setMiddleName]=useState('');

    function changeMiddleName(e){
      // setFirstName(e);
      console.log("eeh=" + e);
      setMiddleName(e ? e: "");
    }

    function handleFirstNameChange(e){
       //console.log("et=" + e.value);
       console.log("e=" + e.target.value);
       try{
        var ee=e.target.value;
       
       }
       catch(Exception){
        console.log("error=" + Exception);
       }
       console.log("fn=" + firstName);
       console.log("ee=" + ee);
       
       //props.value ? props.value : ""
      // e.target.value ? changeFirstName(e.target.value) : ""
       //changeFirstName(ee);
       console.log("fn1=" + firstName);
       
      }
     
      const [fName, setFName]=useState("f name");
    
    return (
      <Box m="20px">
      
      {/** <Button>RECORDS</Button> **/}
      {/**/}
      <Button type="submit" color="secondary" variant="contained"
      onClick={tOPButtonOnClick}
      >
        {topButtonLabel}
      </Button>
      {/**/}
      <span>
      
      </span>
      
      <br/>
      
      {!showForm && (
      <div style={{height: '1200px'}}>
        <br/>
        <TableXDataGrid url={patientsRecordsUrl} tableColumns={tableXDataGridColumns}></TableXDataGrid>
      </div>
      )}
      
      {showForm && (<div>
      <Header title="CREATE USER" subtitle="Create a New User Profile" />
      
      {/* "handleSubmit" will validate your inputs before invoking "onSubmit" */}
      <TXTRoundedDiv style={{border: '1px solid #6BD5C0'}}>
          <StyledInput 
           placeholder="Full Name"
           //value={firstName}
           defaultValue=""
           onChange={event => event.target.value?
            setFName("" + event.target.value + "")
             //setFName("error")
             : 
             setFirstName("error")}
            
           //inputProps="{'type':'String'}"
            />
            <span>{fName}</span>
          </TXTRoundedDiv>
      <form onSubmit={handleSubmit(onSubmit)}>
        {/* register your input into the hook by invoking the "register" function */}
        
        <Stack direction="row" spacing={1} justifyContent="space-between">

          <StyledBox flex={4}>
            
        
          
           <TXTRoundedDiv style={{border: '1px solid #6BD5C0'}}>
           <StyledInput 
           //value={firstName}
           onChange={(event)=>{
            console.log("123")
            setFirstName(event.target.value);
            console.log("AUDIT=" + event.target.value);
            //setPatientGender({value: event.value, label:event.value});
          }}
           placeholder="First Name"
           {...register("txtFirstName", { required: true })}
            />
           {errors.txtFirstName && <span sx={{color: "red", }}>This field is required</span>}
           </TXTRoundedDiv>
           
           {/** **/}
           <TXTRoundedDiv>
           <StyledInput 
           placeholder="Middle Name"
           {...register("txtMiddleName", { required: true })}
            />
           {errors.txtMiddleName && <span>This field is required</span>}
           </TXTRoundedDiv>

           
           <TXTRoundedDiv>
           <StyledInput 
           placeholder="Last Name"
           {...register("txtLastName", { required: true })}
            />
           {errors.txtLastName && <span>This field is required</span>}
           </TXTRoundedDiv>

           <TXTRoundedDiv>
           <StyledInput 
           placeholder="Mobile No"
           {...register("txtMobileNo", { required: true })}
            />
           {errors.txtMobileNo && <span>This field is required</span>}
           </TXTRoundedDiv>
          

           <TXTRoundedDiv>
            
           <Controller
              sx={{
               
              }}
              name="cboGender"
              value={patientGender}
              
              control={control}
              render={({ field }) => (
                <Select
                  
                  options={genderValues}
                  
                  styles={customStyles}
                  onChange={(event)=>{
                    console.log("AUDIT=" + event.value);
                    setPatientGender({value: event.value, label:event.value});
                  }}
                  value={patientGender}
                />
              )}
            />
            {errors.cboGender && <span>This field is required</span>}
            </TXTRoundedDiv>

            {/***/}
           
            {/***/}
             
           
           
          </StyledBox>
          
          <StyledBox flex={4}>    
         

           <TXTRoundedDiv>
           <StyledInput 
           placeholder="Age"
           {...register("txtAge", { required: true })}
            />
           {errors.txtAge && <span>This field is required</span>}
           </TXTRoundedDiv>
           
           
           <TXTRoundedDiv>
           <StyledInput 
           placeholder="Date of birth"
           {...register("dtpDOB", { required: true })}
            />
           {errors.dtpDOB && <span>This field is required</span>}
           </TXTRoundedDiv>
           
           <br>
           
           {/** onChangeDOB */}
           
           {/** <AntdDatePicker getDateFromADP={getDateFromADP} /> **/}

           {/** <Axntd /> **/}
           
           {/** **/} 
           {/** <DatePicker onChange={onChangeDOB} /> **/}
           {/** **/}
            
           {/** */}
           {/** **/}
           {/** **/}
           {/**
           <DateTimePicker
            label="Date of birth"
            value={patientDOB}
            onChange={(newValue) => setPatientDOB(newValue)}
            />
            **/}
           </br>
           {/**
           <DayPicker
            mode="single"
            selected={patientDOB}
            
            onSelect={()=>{
              console.log("ABC")
            }}
           />
           **/}
           {/** footer={footer}
           <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DemoContainer components={['DateTimePicker', 'DateTimePicker']}>
              
              <DateTimePicker
                label="Controlled picker"
                value={patientDOB}
                onChange={(newValue) => setValue(newValue)}
              />
            </DemoContainer>
            </LocalizationProvider>
            **/}

           
           <TXTRoundedDiv>
           <StyledInput 
           placeholder="Address"
           {...register("txtAddress", { required: true })}
            />
           {errors.txtAddress && <span>This field is required</span>}
           </TXTRoundedDiv>
            {/** **/}
           {/** cboPaymentMethodHC **/}
           
           {/**  **/}
           <TXTRoundedDiv>
            
            {/**
            **/}
           
           <TXTRoundedDiv>
           <Controller
              name="cboPaymentMethodHC"
              value={insuranceCategory}
              
              control={control}
              render={({ field }) => (
                <Select
                  {...field}
                  options={insuranceCategoryValues}
                  value={insuranceCategory}
                  /**
                  sx={{
                    width: "100%",
                    fontSize: "14px",
                    backgroundColor: "grey",
                    fontColor: "black",
                    height: "95%",
                    marginBottom: "2px",
                    marginTop: "2px",
                  }}
                  **/
                  styles={customStyles}

                  onChange={(event)=>{
                    console.log("AUDIT" + event.value);
                    setInsuranceCategory({value: event.value, label: event.value});
                  }}
                />
              )}
            />
            {errors.cboPaymentMethodHC && <span>This field is required</span>}
            {insuranceCategory=="Select Insurance Category" && <span>This field is required</span>}
            </TXTRoundedDiv>
             
           </TXTRoundedDiv>
           
           <TXTRoundedDiv>
           <StyledInput 
           placeholder="Card No"
           {...register("txtCardNo", { required: true })}
            />
           {errors.txtCardNo && <span>This field is required</span>}
           </TXTRoundedDiv>  


           <TXTRoundedDiv>
           <Space direction="vertical"
             
           >
            <DatePicker onChange={onChangeDate} 
            style={{
              height: "35px",
              width: "200%",
              border: "none",
              borderRadius: "0px",
              cursor: "pointer",
              fontSize: "17px",
              margin: "0px",
              padding: "0px"
            }}
            />
            <span>{patientDOB}</span>
           </Space>
           
           </TXTRoundedDiv>
        
          </StyledBox>
          
          <StyledBox flex={4}>

          </StyledBox>

        </Stack>
        
        <Stack direction="row" spacing={1} justifyContent="space-between">
        <Box display="flex" justifyContent="end" mt="20px">
              
              {/***
              <input 
               type="submit"
               sx={{
                  backgroundColor: "#62529c",
                  border: "none",
                  color: "#fff",
                  padding: "15px 30px",
                  textDecoration: "none",
                  margin: "4px 2px",
                  cursor: "pointer",
               }}
              />
               ***/}
              
              <Button type="submit" color="secondary" variant="contained">
                Create New User
              </Button>
        </Box>

        </Stack>
        
        
       

      </form>
      </div>) }
      </Box>
      
    )
  }